export const CONFIG = {
    API_BASEURL:
        (process.env.NEXT_PUBLIC_API_BASEURL as string) ||
        'http://localhost:3001',
    IS_PRODUCTION: process.env.NEXT_PUBLIC_VERCEL_ENV === 'production',
} as const
